import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'

import { openWawelDiagnostics } from '@/lib/androidBridge'
import { useSecretTap } from '@/lib/hooks'

import { OutOfOrderContent, OutOfOrderLogo, OutOfOrderMessage, OutOfOrderOverlay, OutOfOrderTitle } from './OutOfOrder.styles'

interface OutOfOrderProps {
  message: string
}

const OutOfOrder = ({ message }: OutOfOrderProps) => {
  const { t } = useTranslation()
  const handleDiagnosticsTap = useSecretTap(5, 2000, openWawelDiagnostics)

  return (
    <OutOfOrderOverlay role="alert" aria-live="assertive">
      <OutOfOrderContent>
        <OutOfOrderLogo onClick={handleDiagnosticsTap}>
          <SVG src={require('@/assets/img/logo.svg').default}></SVG>
        </OutOfOrderLogo>
        <OutOfOrderTitle>{t('outOfOrderTitle')}</OutOfOrderTitle>
        <OutOfOrderMessage>{message}</OutOfOrderMessage>
      </OutOfOrderContent>
    </OutOfOrderOverlay>
  )
}

export default OutOfOrder

